/**
 * @file 紙面に出す画像の URL を返す (デコードを終えたものだけ)。
 * @why: src を差し替えたあとデコードが終わるまで、WebKit は紙面を表示せず背景色になる。
 *   新しい URL のデコードが終わるまでは前の URL を返し、表示中の紙面を残したまま差し替える。
 *   取得中 (null) の間も前の URL を返す。※なぜなら先読みが間に合わないたびに紙面を
 *   「読み込み中」の文字に替えると、続けてページを送ったときにちらつくためである。
 * @failure: decode の無い環境 (jsdom) では受け取った URL をそのまま返す。最初の画像が届くまでは
 *   null を返す。
 */

import { useEffect, useState } from "react";
import { canDecodeImage, decodeImage } from "../lib/imageDecode";

export function useDecodedImageUrl(url: string | null): string | null {
  const [decoded, setDecoded] = useState<string | null>(null);

  useEffect(() => {
    // 取得中は、表示中の画像を残す
    if (!url) return;
    if (!canDecodeImage()) {
      setDecoded(url);
      return;
    }
    let cancelled = false;
    decodeImage(url).then(() => {
      if (!cancelled) setDecoded(url);
    });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (url && !canDecodeImage()) return url;
  return decoded;
}
